const [DAGRE_EDGE_SEP, DAGRE_NODE_SEP, DAGRE_RANK_SEP] = [48, 48, 160] as const;

export { DAGRE_EDGE_SEP, DAGRE_NODE_SEP, DAGRE_RANK_SEP };
